/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DayDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDate from 'Data/date.js'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function DayDate({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/SlotsPopover/DateAndMetrics/DayDate"
  
}) {
let calendarDayDateValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'date',
})
let constantData = 'EEEE, MMMM dd, yyyy'
let aggregateData = fromDate.format(calendarDayDateValueData, constantData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral900}
 data="calendar_day.date"
 data="'EEEE, MMMM dd, yyyy'"
 aggregate="/Data/date.js format"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}